import helpers from './helpers'
import moment from 'moment'

export default {

  // can be called as something | fallback('-')  and will output the fallback only if value is empty (or 0)
  fallback: ( value, fallback ) => {
    if( value === undefined ) return fallback
    if( value === null ) return fallback
    return value
  },

  // same as fallback, but will not allow zeros to pass though
  fallback2: ( value, fallback ) => {
    if( value === undefined ) return fallback
    if( value === null ) return fallback
    if( value === 0 ) return fallback
    return value
  },

  uppercase: ( value ) => {
    return value.toUpperCase()
  },

  int: ( value ) => {
    return parseInt(value)
  },

  float: ( value ) => {
    return parseFloat(value)
  },

  string: ( value ) => {
    return '' + value + ''
  },

  decimals: ( value, decimals ) => {
    if( value === undefined ) return value
    if( !value.toFixed ) return value
    return parseFloat(value.toFixed(decimals))
  },

  double: ( value ) => {
    return value * 2
  },

  round: ( value ) => {
    return Math.round(value)
  },
  
  date: ( value, format ) => {
    if( !value ) return '?'
    return moment.unix(value).format(format)
  },

  money: ( value, decimals ) => {
    return helpers.outputMoney( value, decimals )
  },

  thousandSep: ( value ) => {
    return Math.round(value)
  },
  
  
  boolstr: ( value, str ) => {
    if( value ) return str[0]
    if( !value ) return str[1]
  },

  weekday1dk: ( value ) => {
    return value
      .replace('Mon','M')
      .replace('Tue','T')
      .replace('Wed','O')
      .replace('Thu','T')
      .replace('Fri','F')
      .replace('Sat','L')
      .replace('Sun','S')
      .replace('Mo','M')
      .replace('Tu','T')
      .replace('We','O')
      .replace('Th','T')
      .replace('Fr','F')
      .replace('Sa','L')
      .replace('Su','S')
  },

  cut: (value, length ) => {
    if( !value ) return value
    if( value.length > length ) return value.slice(0,length)+'...'
    return value
    
  },

  milkinitials: ( value ) => {
    return value.replace('@milk-studio.dk','').toUpperCase()
  },
  
  tr_payment_model: ( value ) => {
    if( value === 'fixed_price' ) return 'Fast pris'
    if( value === 'time_expense' ) return 'Timepris'
  },
  
  tr_project_status: ( value ) => {
    if( value === 'active' ) return 'Aktiv'
    if( value === 'draft' ) return 'Skitse'
    if( value === 'finished' ) return 'Afsluttet'
    if( value === 'aborted' ) return 'Aflyst'
  },
  


}


// WEBPACK FOOTER //
// ./src/filters.js